import i18next from "i18next";
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Meta } from "../../Components/Helpers/Meta";
import { Navbar } from "../../Components/Navbar/Navbar";
import "./qr.css";

const QR = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        fullName: '',
        title: '',
        workPhone: '',
        mobilePhone: '',
        extension: '',
        fax: '',
        email: '',
        linkedin: ''
    });
    const [qrGenerated, setQrGenerated] = useState(false);
    const qrRef = useRef(null);

    useEffect(() => {
        document.title = "QR - Cevher";
    }, []);

    const language = i18next.language;
    const { lang } = useParams();

    const imagesrc = require("../../assets/hero/career.d588ee6e.jpg");
    const fullUrl = `https://cevher.com${imagesrc}`;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.fullName && (formData.workPhone || formData.mobilePhone) && formData.email) {
            setQrGenerated(true);
        }
    };

    const resetForm = () => {
        setFormData({
            fullName: '',
            title: '',
            workPhone: '',
            mobilePhone: '',
            extension: '',
            fax: '',
            email: '',
            linkedin: ''
        });
        setQrGenerated(false);
    };

    function toQuotedPrintable(str) {
        return unescape(encodeURIComponent(str))
            .split('')
            .map(char => {
                const code = char.charCodeAt(0);
                return (code > 127 || code === 61)
                    ? '=' + code.toString(16).toUpperCase().padStart(2, '0')
                    : char;
            })
            .join('');
    }

    const generateVCardData = () => {
        return `BEGIN:VCARD
VERSION:3.0
FN;CHARSET=UTF-8;ENCODING=QUOTED-PRINTABLE:${toQuotedPrintable(formData.fullName)}
TITLE;CHARSET=UTF-8;ENCODING=QUOTED-PRINTABLE:${toQuotedPrintable(formData.title)}
${formData.workPhone ? `TEL;TYPE=WORK,VOICE:${formData.workPhone}` : ''}
${formData.mobilePhone ? `TEL;TYPE=CELL,VOICE:${formData.mobilePhone}` : ''}
${formData.extension ? `X-EXTENSION:${formData.extension}` : ''}
${formData.fax ? `TEL;TYPE=FAX:${formData.fax}` : ''}
EMAIL:${formData.email}
${formData.linkedin ? `URL:${formData.linkedin}` : ''}
END:VCARD`;
    };

    const downloadQRCode = () => {
        const svg = qrRef.current.querySelector('svg');
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);

        img.onload = () => {
            const scaleFactor = 4;
            canvas.width = img.width * scaleFactor;
            canvas.height = img.height * scaleFactor;
            ctx.scale(scaleFactor, scaleFactor);
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);

            const pngUrl = canvas.toDataURL('image/png');
            const downloadLink = document.createElement('a');
            downloadLink.href = pngUrl;
            downloadLink.download = 'cevher-contact.png';
            downloadLink.click();
        };
        img.src = url;
    };

    return (
        <div>
            <Meta title={t("career")} description={t("career-title")} lang={lang} metaimg={fullUrl} />
            <Navbar />
            <div className="c-wrapper">
                <div className="c-hero">
                    <div className="c-hero-background">
                        <picture>
                            <img
                                className="c-hero-image"
                                alt=""
                                src={require("../../assets/hero/information-security-policy.a954fd04.jpg")}
                            />
                        </picture>
                    </div>
                    <div className="c-hero-body">
                        <div className="c-about-caption">
                            <div className="c-caption-section" style={{ color: "#fff", textAlign: "center" }}>
                                {t("qr")}
                            </div>
                            <h1 className="c-caption-header">{t("qr-header")}</h1>
                        </div>
                    </div>
                </div>

                <div className="c-container" style={{ marginTop: "2.5rem" }}>
                    <div className="c-row">
                        <div className="c-col c-col--lg-8 c-col--offset-lg-2">
                            {!qrGenerated ? (
                                <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">
                                    <div className="c-career-row">

                                        {/* Full Name */}
                                        <div className="c-col c-col--lg-12">
                                            <div className="c-career-form-group">
                                                <span className="c-career-form-group-label">
                                                    <label>{t("contact-name-surname")} *</label>
                                                </span>
                                                <input
                                                    type="text"
                                                    name="fullName"
                                                    value={formData.fullName}
                                                    onChange={handleChange}
                                                    required
                                                    className="c-career-form-group-input c-career-form-control"
                                                />
                                            </div>
                                        </div>

                                        {/* Title */}
                                        <div className="c-col c-col--lg-6">
                                            <div className="c-career-form-group">
                                                <span className="c-career-form-group-label">
                                                    <label>{t("qr-title")}</label>
                                                </span>
                                                <input
                                                    type="text"
                                                    name="title"
                                                    value={formData.title}
                                                    onChange={handleChange}
                                                    className="c-career-form-group-input c-career-form-control"
                                                />
                                            </div>
                                        </div>

                                        {/* Work Phone */}
                                        <div className="c-col c-col--lg-6">
                                            <div className="c-career-form-group">
                                                <span className="c-career-form-group-label">
                                                    <label>{t("contact-work-phone")}</label>
                                                </span>
                                                <input
                                                    type="text"
                                                    name="workPhone"
                                                    value={formData.workPhone}
                                                    onChange={handleChange}
                                                    placeholder="+90 3xx xxx xx xx"
                                                    className="c-career-form-group-input c-career-form-control"
                                                />
                                            </div>
                                        </div>

                                        {/* Mobile Phone */}
                                        <div className="c-col c-col--lg-6">
                                            <div className="c-career-form-group">
                                                <span className="c-career-form-group-label">
                                                    <label>{t("contact-mobile-phone")} *</label>
                                                </span>
                                                <input
                                                    type="text"
                                                    name="mobilePhone"
                                                    value={formData.mobilePhone}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="+90 5xx xxx xx xx"
                                                    className="c-career-form-group-input c-career-form-control"
                                                />
                                            </div>
                                        </div>

                                        {/* Extension */}
                                        <div className="c-col c-col--lg-6">
                                            <div className="c-career-form-group">
                                                <span className="c-career-form-group-label">
                                                    <label>{t("contact-extension")}</label>
                                                </span>
                                                <input
                                                    type="text"
                                                    name="extension"
                                                    value={formData.extension}
                                                    onChange={handleChange}
                                                    placeholder="123"
                                                    className="c-career-form-group-input c-career-form-control"
                                                />
                                            </div>
                                        </div>

                                        {/* Fax */}
                                        <div className="c-col c-col--lg-6">
                                            <div className="c-career-form-group">
                                                <span className="c-career-form-group-label">
                                                    <label>{t("contact-fax")}</label>
                                                </span>
                                                <input
                                                    type="text"
                                                    name="fax"
                                                    value={formData.fax}
                                                    onChange={handleChange}
                                                    placeholder="+90 3xx xxx xx xx"
                                                    className="c-career-form-group-input c-career-form-control"
                                                />
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <div className="c-col c-col--lg-6">
                                            <div className="c-career-form-group">
                                                <span className="c-career-form-group-label">
                                                    <label>{t("contact-email")} *</label>
                                                </span>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="email@domain.com"
                                                    className="c-career-form-group-input c-career-form-control"
                                                />
                                            </div>
                                        </div>

                                        {/* LinkedIn */}
                                        <div className="c-col c-col--lg-6">
                                            <div className="c-career-form-group">
                                                <span className="c-career-form-group-label">
                                                    <label>LinkedIn</label>
                                                </span>
                                                <input
                                                    type="url"
                                                    name="linkedin"
                                                    value={formData.linkedin}
                                                    onChange={handleChange}
                                                    placeholder="https://www.linkedin.com/in/kullaniciadi"
                                                    className="c-career-form-group-input c-career-form-control"
                                                />
                                            </div>
                                        </div>

                                        {/* Submit button full width */}
                                        <div className="c-col c-col--lg-12">
                                            <input
                                                type="submit"
                                                className="c-button"
                                                value={t("generate-qr")}
                                                style={{ marginTop: "1.5rem", width: "100%" }}
                                            />
                                        </div>
                                    </div>
                                </form>
                            ) : (
                                <div className="c-career-container">
                                    <div className="c-row" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                        <div className="c-col c-col--lg-12" style={{ textAlign: "center" }}>
                                            <div style={{ padding: "2rem 0" }}>
                                                <div className="personal-info" style={{ marginBottom: "2rem" }}>
                                                    <h4>{formData.fullName}</h4>
                                                    {formData.title && <p>{formData.title}</p>}
                                                    {formData.workPhone && <p><strong>{t("contact-work-phone")}:</strong> {formData.workPhone}</p>}
                                                    {formData.mobilePhone && <p><strong>{t("contact-mobile-phone")}:</strong> {formData.mobilePhone}</p>}
                                                    {formData.extension && <p><strong>{t("contact-extension")}:</strong> {formData.extension}</p>}
                                                    {formData.fax && <p><strong>{t("contact-fax")}:</strong> {formData.fax}</p>}
                                                    <p><strong>{t("contact-email")}:</strong> {formData.email}</p>
                                                    {formData.linkedin && <p><strong>LinkedIn:</strong> <a href={formData.linkedin} target="_blank" rel="noreferrer">{formData.linkedin}</a></p>}
                                                </div>

                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "2rem" }}>
                                                    <div ref={qrRef} className="qr-container" style={{
                                                        padding: "1.5rem",
                                                        border: "1px dashed #ccc",
                                                        borderRadius: "8px",
                                                        background: "white"
                                                    }}>
                                                        <QRCodeSVG
                                                            value={generateVCardData()}
                                                            size={200}
                                                            level="H"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="c-career-row" style={{ justifyContent: "center", marginTop: "1.5rem" }}>
                                                    <button className="c-button" style={{ margin: "1rem" }} onClick={downloadQRCode}>
                                                        {t("download-qr")}
                                                    </button>
                                                    <button className="c-button c-button--secondary" style={{ margin: "1rem" }} onClick={resetForm}>
                                                        {t("create-new-qr")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QR;
